import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-client-appointment-detail',
  templateUrl: './client-appointment-detail.component.html',
  styleUrls: ['./client-appointment-detail.component.scss']
})
export class ClientAppointmentDetailComponent implements OnInit {
  action!: string;

  constructor(private router: Router, private auth: AuthenticationService, private activatedRoute: ActivatedRoute, private appointmentService: AppointmentService, private spinner: NgxSpinnerService) { }
  apptId: any
  apptDetails: any
  startAsses: boolean = false
  comments: string = ""
  userRole: any
  appts: any
  appointmentComments: any
  show: boolean = false
  ngOnInit(): void {
    this.show = false
    this.spinner.show()
    this.userRole = this.auth.getUserType()
    this.activatedRoute.params.subscribe(params => {
      this.apptId = params['appointmentId']
    });

    this.appointmentService.getAppointments(null, null, null, this.apptId, null, null).subscribe(res => {
      this.apptDetails = res.data[0]
      this.appointmentComments = this.apptDetails.appointmentComments;
      if (this.appointmentComments == "" || this.appointmentComments == null) {
        this.appointmentComments = "-"
      }
      this.appts = this.apptDetails.parentDetails

      for (let i in this.appts) {

        if (this.appts[i] == "" || this.appts[i] == null) {
          this.appts[i] = '-'
        }

      }

      this.spinner.hide();
      this.show = true

    })
  }

  finishAppt(action: any) {
    if (action == "Cancel") {
      this.action = "CANCEL"
    }
    else {

      this.action = "COMPLETE"
    }
  }


  startAssesment() {

    this.router.navigate(['/student-observation'])

  }

}
